import React from "react";

const Wishlist = props => {
  return <h1>Welcome to wishlist!</h1>
}

export default Wishlist;